<div class="header-box">
  <div class="d-flex align-items-center heading-box">
    <ng-icon [name]="
        mode == 'view'
          ? 'heroDocumentMagnifyingGlass'
          : mode == 'edit'
          ? 'heroClipboardDocumentCheck'
          : 'heroDocumentPlus'
      "></ng-icon>
    <div>
      <h2 *ngIf="mode">
        <small>{{ mode + " Clause" | titlecase }}</small>
      </h2>
      <h2 *ngIf="formLoading; else loaded">
        <ngx-skeleton-loader [theme]="{ height: '20px', width: '200px' }"></ngx-skeleton-loader>
      </h2>
      <ng-template #loaded>
        <h2>{{ id ? clause.name : "Add Clause" }}</h2>
      </ng-template>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center col-md-6 p-0">
    <button color="accent" mat-raised-button *ngIf="userService.permissionsValue['_CLAUSES_EDIT_'] && mode == 'view'"
      [routerLink]="['/app/clause', 'edit', id]">
      Edit Clause
    </button>
  </div>
</div>

<div class="inner-box">
  <mat-card class="without-expansion">
    <mat-card-content class="form-head">
      <div *ngIf="formLoading; else show">
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px', width: '50%' }"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px', width: '50%' }"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '100px', width: '50%' }"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right' }"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{
              height: '50px',
              width: '30px',
              opacity: '0',
              float: 'right',
              visibility: 'hidden'
            }"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right' }"></ngx-skeleton-loader>
        </div>
      </div>
      <ng-template #show>
        <form [formGroup]="clauseForm" (ngSubmit)="submitClause()">
          <div class="flex-wrap d-flex p-0">
            <div class="col-md-4">
              <div class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-label>Select Contract Type</mat-label>
                  <input type="text" matInput [matAutocomplete]="auto" formControlName="contractTypeName"
                    (input)="onInputChange($event.target.value)" #contractInput [errorStateMatcher]="matcher" />
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onContractTypeSelect($event)">
                    <mat-option disabled *ngIf="isNotFound">No Items Found</mat-option>
                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="
                      clauseForm.get('contractTypeName').hasError('required')
                    ">
                    Contract Type is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-label>Clause name</mat-label>
                  <input type="text" matInput autocomplete="off" formControlName="name" [errorStateMatcher]="matcher" />
                  <mat-error *ngIf="clauseForm.get('name').hasError('required')">
                    Clause name is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="col-md-12 d-flex p-0">
              <div class="col-md-4">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Clause Description</mat-label>
                    <input type="text" matInput autocomplete="off" formControlName="description"
                      [errorStateMatcher]="matcher" />
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-4">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Select Language</mat-label>
                    <mat-select formControlName="language_Id" [errorStateMatcher]="matcher">
                      <mat-option *ngFor="let lang of languages" [value]="lang.id">{{ lang.name }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="clauseForm.get('language_Id').hasError('required')">
                      Language is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0">
              <div class="col-md-8">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Clause Text</mat-label>
                    <textarea matInput formControlName="text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8" [errorStateMatcher]="matcher"></textarea>
                    <mat-error *ngIf="clauseForm.get('text').hasError('required')">
                      Clause Text is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0">
              <div class="col-md-4">
                <mat-checkbox formControlName="isMandatory" color="primary">Mandatory</mat-checkbox>
                <mat-checkbox formControlName="isTracked" color="primary" class="ml-3">Tracked</mat-checkbox>
              </div>
            </div>
          </div>

          <div class="col-md-12 d-flex p-0 justify-content-end" *ngIf="mode != 'view'">
            <button color="primary" class="outlined-btn" mat-raised-button (click)="reset()" type="reset"
              [disabled]="isLoading">
              Reset
            </button>
            <button color="accent" mat-raised-button type="submit" class="ml-3" [disabled]="isLoading">
              {{ id ? "Update" : "Submit" }}
              <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
            </button>
          </div>
        </form>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>